import { PromoBannerData } from '@model/promo-banner';

export const bannerIsActive = (banner: PromoBannerData) => {
  const activeFromTimestamp: number | null = banner.activeFrom ? new Date(banner.activeFrom).getTime() : null;
  const activeToTimestamp: number | null = banner.activeTo ? new Date(banner.activeTo).getTime() : null;
  const currentTimestamp: number = new Date().getTime();

  const isActive: boolean =
    (!activeFromTimestamp || (!!activeFromTimestamp && activeFromTimestamp <= currentTimestamp)) &&
    (!activeToTimestamp || (!!activeToTimestamp && activeToTimestamp >= currentTimestamp));
  return isActive;
};
